import { message, Spin } from "antd";
import { onMessage } from "firebase/messaging";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import AboutYou from "./Pages/about-you";
import Dashboard from "./Pages/dashboard";
import Expenses from "./Pages/expenses";
import Income from "./Pages/income";
import Report from "./Pages/report";
import SettingsMain from "./Pages/settings";
import GeneralInfoModal from "./components/common/InfoModal";
import PrivacyPolicy from "./components/common/PrivacyPolicy";
import TermsAndConditions from "./components/common/TermsAndConditions";
import ForgotPassword from "./components/common/auth/ForgotPassword";
import ResetPassword from "./components/common/auth/ResetPassword";
import SelectLanguage from "./components/common/auth/SelectLanguage";
import Splash from "./components/common/auth/Splash";
import VerificationCode from "./components/common/auth/VerificationCode";
import Login from "./components/common/auth/login-singup/Login";
import SignUp from "./components/common/auth/login-singup/SignUp";
import GetStarted from "./components/common/create-profile/GetStarted";
import LeaveInCanadaNoScreen from "./components/common/create-profile/about-you/LeaveInCanadaNoScreen";
import { generateToken, messaging } from "./firebase";
import { setLoading } from "./redux/slices/common_slice";
import "./responsive.css";
import ProtectedRoute from "./routing/protectedRoute";
import { routePaths } from "./routing/routePaths";
import EmailVerified from "./components/common/EmailVerified";

function App() {
  const loading = useSelector((state) => state.common?.loading || false);
  const dispatch = useDispatch();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, [window.location.pathname]);
  useEffect(() => {
    dispatch(setLoading(false));
    generateToken();
    const unsub = onMessage(messaging, (payload) => {
      message.open({
        key: "notification-1",
        icon: <img src="/assets/images/icons/logo-favicon.svg" width={22} />,
        content: (
          <div
            onClick={() => handleResourceNavigation(payload?.data)}
            style={{ marginLeft: "10px", textAlign: "left" }}
          >
            <h6 className="mb-1">{payload.data?.title}</h6>
            <p className="mb-0" style={{ textAlign: "left" }}>
              {payload.data?.body}
            </p>
          </div>
        ),
      });
    });
    return () => {
      unsub();
    };
  }, []);

  const handleResourceNavigation = (data) => {
    window.open(data.url);
    message.destroy("notification-1");
  };

  return (
    <div className="App">
      <Spin
        spinning={loading}
        indicator={
          <img
            src="/assets/images/butterfly-logo.svg"
            style={{ fontSize: 100 }}
          />
        }
        size={"large"}
      >
        <BrowserRouter>
          <Routes>
            <Route path={routePaths.splashScreen} element={<Splash />} />
            <Route
              path={routePaths.selectLanguage}
              element={<SelectLanguage />}
            />
            <Route path={routePaths.login} element={<Login />} />
            <Route
              path={routePaths.income}
              element={
                <ProtectedRoute>
                  <Income />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.getStarted}
              element={
                <ProtectedRoute>
                  <GetStarted />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.onboarding}
              element={
                <ProtectedRoute>
                  <AboutYou />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.expenses}
              element={
                <ProtectedRoute>
                  <Expenses />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.notLivingInCanada}
              element={
                <ProtectedRoute>
                  <LeaveInCanadaNoScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.report}
              element={
                <ProtectedRoute>
                  <Report />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.dashboard}
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.budget}
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path={routePaths.settings}
              element={
                <ProtectedRoute>
                  <SettingsMain />
                </ProtectedRoute>
              }
            />

            <Route path={routePaths.signUp} element={<SignUp />} />
            <Route
              path={routePaths.emailVerified}
              element={<EmailVerified />}
            />
            <Route
              path={routePaths.forgotPassword}
              element={<ForgotPassword />}
            />
            <Route
              path={routePaths.resetPassword}
              element={<ResetPassword />}
            />
            <Route
              path={routePaths.verificationCode}
              element={<VerificationCode />}
            />
            <Route
              path={routePaths.termsAndConditions}
              element={<TermsAndConditions />}
            />
            <Route
              path={routePaths.privacyPolicy}
              element={<PrivacyPolicy />}
            />
          </Routes>
        </BrowserRouter>
      </Spin>
      <GeneralInfoModal />
    </div>
  );
}

export default App;
